import React from 'react';
import { HideInWebview } from './HideInWebView';
export const HideInWebviewHoc = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
WrappedComponent
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props) => (React.createElement(HideInWebview, null,
        React.createElement(WrappedComponent, Object.assign({}, props))));
};
